import clsx from 'clsx';
import React from 'react';

import imgPhone from 'images/pro/Phone.png';
import imgTriangleTop from 'images/pro/TriangleTop.svg';

import useCurrentUser from '@hooks/useCurrentUser';
import { subscribe_promotion_path, upgrade_subscription_path } from '@routes';
import {
  DEFAULT_ANNUAL_OFFER_CODE,
  DEFAULT_MONTHLY_OFFER_CODE,
  DEFAULT_PRO_OFFER_CODE,
  DEFAULT_YP_OFFER_CODE,
} from '@src/constants';

const ProHero = () => {
  const { currentUser } = useCurrentUser();
  const isCurrentUserSubscriber = currentUser?.is_subscriber;
  const isCurrentUserProSubscriber = currentUser?.is_pro_subscriber;

  return (
    <div className="my-32 px-16 xs:px-48 md:mt-72">
      <div className="relative mx-auto flex md:max-w-[1024px]">
        <div className="sm:max-w-[458px] md:max-w-[524px]">
          <p className="m-0 font-sans text-overline uppercase text-primary-red">
            {isCurrentUserSubscriber && !isCurrentUserProSubscriber
              ? 'Upgrade now'
              : !isCurrentUserSubscriber && 'Subscribe'}
          </p>
          <h2 className="m-0 mt-16 font-serif text-headline-lg text-primary-black md-d:text-[32px]">
            Don{'’'}t read the news.
            <br />
            Make the news.
            <br />
            The Information Pro.
          </h2>
          <p className="m-0 mt-16 font-serif text-paragraph text-black">
            The Information Pro is a new service for professionals who need non-public resources to
            excel at their jobs. You{'’'}ll have access to the resources we built for
            ourselves—because we couldn{'’'}t find them anywhere else. Don{'’'}t take a meeting
            without The Information Pro.
          </p>
          {!isCurrentUserProSubscriber && (
            <a
              href={
                isCurrentUserSubscriber
                  ? upgrade_subscription_path()
                  : subscribe_promotion_path({
                      offer: `${DEFAULT_PRO_OFFER_CODE},${DEFAULT_ANNUAL_OFFER_CODE},${DEFAULT_MONTHLY_OFFER_CODE},${DEFAULT_YP_OFFER_CODE}`,
                    })
              }
              className={clsx(
                'bg-primary-red font-sans text-button-md uppercase !text-white',
                'mt-24 flex h-40 items-center justify-center rounded-r-2 xs:w-[245px] md:mt-32',
                'transition-colors hover:bg-pro-red focus:bg-pro-red'
              )}
            >
              {isCurrentUserSubscriber ? 'Upgrade' : 'Get Started'}
            </a>
          )}
        </div>
        <div className="absolute -top-24 left-[150px] w-full mix-blend-multiply xs:w-auto sm:-right-[100px] sm:left-auto md:-top-40">
          <img className="block w-full object-contain object-top" src={imgTriangleTop} alt="" />
        </div>
        <div className="absolute -top-24 right-0 hidden w-[275px] sm:left-[600px] sm:block md:w-[325px]">
          <img className="block w-full object-contain object-top" src={imgPhone} alt="" />
        </div>
        <div className="hidden w-[275px] shrink-0 sm:block" />
      </div>
    </div>
  );
};

export default ProHero;
